import { SpecialAnchorTypes, ToolTypes } from '@labradorsports/constants';

import {
    generateRouteOptionAnchors,
    generateRouteOptionLines,
    generateRouteOptionSelectedAnchors,
    handleRouteOptionDrag,
    handleRouteOptionDragEnd,
} from '../utils/index.js';

import { PluginContext } from './api.js';

export default {
    types: [ToolTypes.ROUTE_OPTION, SpecialAnchorTypes.ROUTE_OPTION_START],
    specialAnchorTypes: [SpecialAnchorTypes.ROUTE_OPTION_ELBOW],
    generateAnchors: generateRouteOptionAnchors,
    generateSelectedAnchors: generateRouteOptionSelectedAnchors,
    generateLines: generateRouteOptionLines,
    handleDragEnd: handleRouteOptionDragEnd,
    handleDrag: handleRouteOptionDrag,
} as PlayPlugin<PluginContext>;
